module.exports = __webpack_public_path__ + "media/images/frame-67eab6aa3f9483a9316999fb06e7462b.png";